module.exports = __webpack_public_path__ + "static/media/3-pos-toe-raises-1.277b3b1f.png";